
export const SubtleBadge = ({ value = '', color = 'success', onClick }) => {

    return (
        <span style={{ cursor: onClick ? 'pointer' : 'default' }} className={`badge text-uppercase bg-${color}-subtle text-${color}`} onClick={onClick}>
            {" "}{value}{" "}
        </span>
    )
}